import { render } from "./FrequencyChanging.vue?vue&type=template&id=f933a9b8&scoped=true&ts=true"
import script from "./FrequencyChanging.vue?vue&type=script&lang=ts"
export * from "./FrequencyChanging.vue?vue&type=script&lang=ts"

import "./FrequencyChanging.vue?vue&type=style&index=0&id=f933a9b8&scoped=true&lang=css"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f933a9b8"]])

export default __exports__